<template>
  <div class="CookiePopupWindow popupWindow">
    <div class="floatingBlock">
      <h3>Ultimaker Cookies</h3>
      <p>
        We use cookies, including cookies from third parties, to enhance your
        user experience and the effectiveness of our marketing activities. These
        cookies are performance, analytics and advertising cookies, please see
        our
        <a
          target="_blank"
          href="https://ultimaker.com/legal/privacy-and-cookie-statement"
          >Privacy and Cookie policy</a
        >
        for further information. If you agree to all of our cookies select
        “Accept all ” or select “Cookie Settings” to see which cookies we use
        and choose which ones you would like to accept
      </p>
      <button class="w-auto mr-30" @click="cookieSettings()">
        Cookie settings
      </button>
      <button class="w-auto" @click="acceptCookies()">Accept all</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PerformancePopupWindow",
  components: {},
  data: () => ({}),
  methods: {
    cookieSettings() {
      window.open(
        "https://ultimaker.com/legal/privacy-and-cookie-statement",
        "_blank"
      );
    },
    acceptCookies() {
      localStorage.setItem("ultimakerCookiePolicy", "true");
      this.$store.commit("cookiePolicy/cookiePolicyCommit", {
        showPopup: false,
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Popups/styles";
</style>
